export default "__VITE_ASSET__CF3OsXmQ__"